import { normalizeMappingProjectKey } from './mappingProjectIdentity';

const MaxUserIdLength = 256;
const MaxProjectKeyLength = 2048;

export function normalizeUserProjectUserId(
  userId: string | null | undefined
): string | null {
  const normalized = userId?.trim().toLowerCase();
  return normalized && normalized.length <= MaxUserIdLength ? normalized : null;
}

export function normalizeUserProjectProjectKey(
  projectKey: string | null | undefined
): string | null {
  const normalized = normalizeMappingProjectKey(projectKey);
  return normalized && normalized.length <= MaxProjectKeyLength ? normalized : null;
}

export function buildUserProjectScopeKey(
  userId: string | null | undefined,
  projectKey: string | null | undefined
): string | null {
  const normalizedUserId = normalizeUserProjectUserId(userId);
  const normalizedProjectKey = normalizeUserProjectProjectKey(projectKey);
  return normalizedUserId && normalizedProjectKey
    ? `${normalizedUserId}::${normalizedProjectKey}`
    : null;
}
